import { render, staticRenderFns } from "./BaseNotAuthenticatedPage.vue?vue&type=template&id=6f636dfa"
import script from "./BaseNotAuthenticatedPage.vue?vue&type=script&lang=js"
export * from "./BaseNotAuthenticatedPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports